export default {
  'zh-tw': {
    userRegistV2: {
      title: '建立您的帳號',
      subtitle: '完成註冊與帳號綁定後，即可繼續填寫進階資料。',
      subtitle2: '完成進階資料後，即可取得授權與啟用服務。',
      completeSubtitle: '您的帳號與授權資訊已準備完成。',
      steps: {
        form: '註冊資料',
        complete: '註冊完成'
      },
      bindTitle: '綁定狀態',
      bindHint: '若來源頁面帶入綁定資訊，對應平台圖示會在此顯示。',
      sections: {
        account: '帳號資料',
        profile: '進階資料'
      },
      step2SuccessTitle: '恭喜您，帳號已建立完成。',
      step2SuccessCopy: '請繼續補齊進階資料，以完成授權開通流程。',
      primaryAction: '完成註冊',
      secondaryAction: '稍後再說',
      completeBadge: 'CONGRATULATIONS',
      completeTitle: '恭喜您已成功解鎖以下授權！',
      completeLicenses: {
        hiteach: {
          name: 'HiTeach 50人 (HiTeach 333 階段一)',
          duration: '3個月'
        },
        aiPack: {
          name: 'AI/GPT 智連環+智慧評分+協作 (Hi禮包)',
          duration: '1個月'
        },
        doubleAi: {
          name: '雙AI (文句分析+小數據)',
          duration: '1年'
        }
      },
      completeQrTitle: '請點擊或掃描QR Code下載安裝HiTA 5 App',
      completeQrItems: {
        ios: 'iPhone iOS系統安裝',
        androidPlay: 'Android系統安裝',
        androidApk: 'Android下載APK安裝'
      },
      notify: {
        title: 'HiTeach歡迎您的加入🎉',
        body: '親愛的{name}老師({tmdId})，您好\n恭喜您成功註冊 醍摩豆(TEAM Model) 會員！\n\nHiTeach 亮點功能👉\n✅ AI 智慧助教：自動整理、生成教學資料\n✅ 互動式提問：提升學生參與度\n✅ 多元測驗模式：即時測驗更彈性\n✅ 數據分析報告：快速掌握學生學習成效\n\n即刻開始您的 HiTeach 探索之旅：'
      },
      loginHT: '點我開始使用HiTeach'
    }
  },
  'zh-cn': {
    userRegistV2: {
      title: '创建您的账号',
      subtitle: '完成注册与账号绑定后，即可继续填写进阶资料。',
      subtitle2: '完成进阶资料后，即可取得授权与启用服务。',
      completeSubtitle: '您的账号设置预览已完成。',
      steps: {
        form: '注册资料',
        complete: '注册完成'
      },
      bindTitle: '绑定状态',
      bindHint: '如果来源页面带入绑定信息，对应平台图示会在此显示。',
      sections: {
        account: '账号资料',
        profile: '进阶资料'
      },
      step2SuccessTitle: '恭喜您，账号已建立完成。',
      step2SuccessCopy: '请继续补齐进阶资料，以完成授权开通流程。',
      primaryAction: '完成注册',
      secondaryAction: '稍后再说',
      completeBadge: 'CONGRATULATIONS',
      completeTitle: '恭喜您已成功解锁以下授权！',
      completeLicenses: {
        hiteach: {
          name: ' HiTeach 50人 (HiTeach 333 阶段一)',
          duration: '3个月'
        },
        aiPack: {
          name: 'GAI 智连环+智慧评分+协作模组 (Hi礼包)',
          duration: '1个月'
        },
        doubleAi: {
          name: '双AI (文句分析+小数据)',
          duration: '1年'
        }
      },
      completeQrTitle: '请点击或扫描QR Code下载安装HiTA 5 App',
      completeQrItems: {
        ios: 'iPhone iOS系統安裝',
        androidPlay: 'Android系統安裝',
        androidApk: 'Android下载APK安装'
      },
      notify: {
        title: 'HiTeach欢迎您的加入🎉',
        body: '亲爱的{name}老師({tmdId})，您好\n恭喜您成功注册 醍摩豆(TEAM Model) 会员！\n\nHiTeach 亮点功能👉\n✅ AI 智慧助教：自动整理、生成教学资料\n✅ 互动式提问：提升学生参与度\n✅ 多元测验模式：即时测验更弹性\n✅ 数据分析报告：快速掌握学生学习成效\n\n即刻开始您的 HiTeach 探索之旅：'
      },
      loginHT: '点我开始使用HiTeach'
    }
  },
  'en-us': {
    userRegistV2: {
      title: 'Create your account',
      subtitle: 'Complete your registration and profile details in one smooth step.',
      subtitle2: 'Complete your profile to activate your license.',
      completeSubtitle: 'Your account setup preview is complete.',
      steps: {
        form: 'Register',
        complete: 'Complete'
      },
      bindTitle: 'Binding status',
      bindHint: 'If a source page passes a binding provider, the matching icon lights up here.',
      sections: {
        account: 'Account Information',
        profile: 'Advanced Profile'
      },
      step2SuccessTitle: 'Congratulations, your account has been created.',
      step2SuccessCopy: 'Complete your advanced profile details to activate your service.',
      primaryAction: 'Complete registration',
      secondaryAction: 'Maybe later',
      completeBadge: 'Congratulations',
      completeTitle: 'Congratulations! You have unlocked the following licenses!',
      completeLicenses: {
        hiteach: {
          name: 'HiTeach License (HiTeach 333 Stage 1)',
          duration: '3 Months'
        },
        aiPack: {
          name: 'Collaboration + Smart Rating + AI GPT',
          duration: '1 Month'
        },
        doubleAi: {
          name: 'Dual AI Gadgets',
          duration: '1 Year'
        }
      },
      completeQrTitle: 'Click or scan the QR code to download and install the HiTA 5 App',
      completeQrItems: {
        ios: 'Installation for iPhone iOS',
        androidPlay: 'Installation for Android',
        androidApk: 'Download HiTA 5 APK to Install'
      },
      notify: {
        title: 'Welcome to HiTeach 🎉',
        body: 'Dear {name} ({tmdId}),\nCongratulations on registering as a TEAM Model member!\n\nHighlight Features of HiTeach👉\n✅ AI Smart Teaching Assistant\n✅ Interactive Questioning\n✅ Multiple Assessment Modes\n✅ Data Analysis Reports\n\nStart your HiTeach exploration journey now:'
      },
      loginHT: 'Click to start using HiTeach'
    }
  },
  'ja-jp': {
    userRegistV2: {
      title: 'アカウントを作成',
      subtitle: '登録とアカウント連携を完了すると、追加情報を入力できます。',
      subtitle2: '追加情報の入力後、ライセンスを有効化できます。',
      completeSubtitle: 'アカウント設定のプレビューが完了しました。',
      steps: {
        form: '登録情報',
        complete: '完了'
      },
      bindTitle: '連携状態',
      bindHint: '元ページから連携情報が渡された場合、該当するアイコンがここで点灯します。',
      sections: {
        account: 'アカウント情報',
        profile: '追加プロフィール'
      },
      step2SuccessTitle: 'おめでとうございます。アカウントが作成されました。',
      step2SuccessCopy: '追加プロフィールを入力してサービスを有効化してください。',
      primaryAction: '登録を完了',
      secondaryAction: '後で',
      completeBadge: 'CONGRATULATIONS',
      completeTitle: 'Congratulations! You have unlocked the following licenses!',
      completeLicenses: {
        hiteach: {
          name: 'HiTeach License (HiTeach 333 Stage 1)',
          duration: '3 Months'
        },
        aiPack: {
          name: 'Collaboration + Smart Rating + AI GPT',
          duration: '1 Month'
        },
        doubleAi: {
          name: 'Dual AI Gadgets',
          duration: '1 Year'
        }
      },
      completeQrTitle: 'Click or scan the QR code to download and install the HiTA 5 App',
      completeQrItems: {
        ios: 'Installation for iPhone iOS',
        androidPlay: 'Installation for Android',
        androidApk: 'Download HiTA 5 APK to Install'
      },
      notify: {
        title: 'Welcome to HiTeach 🎉',
        body: 'Dear {name} ({tmdId}),\nCongratulations on registering as a TEAM Model member!\n\nHighlight Features of HiTeach👉\n✅ AI Smart Teaching Assistant\n✅ Interactive Questioning\n✅ Multiple Assessment Modes\n✅ Data Analysis Reports\n\nStart your HiTeach exploration journey now:'
      },
      loginHT: 'Click to start using HiTeach'
    }
  },
  'ko-kr': {
    userRegistV2: {
      title: 'Create your account',
      subtitle: 'Complete your registration and profile details in one smooth step.',
      subtitle2: 'Complete your profile to activate your license.',
      completeSubtitle: 'Your account setup preview is complete.',
      steps: {
        form: 'Register',
        complete: 'Complete'
      },
      bindTitle: 'Binding status',
      bindHint: 'If a source page passes a binding provider, the matching icon lights up here.',
      sections: {
        account: 'Account Information',
        profile: 'Advanced Profile'
      },
      step2SuccessTitle: 'Congratulations, your account has been created.',
      step2SuccessCopy: 'Complete your advanced profile details to activate your service.',
      primaryAction: 'Complete registration',
      secondaryAction: 'Maybe later',
      completeBadge: 'Congratulations',
      completeTitle: 'Congratulations! You have unlocked the following licenses!',
      completeLicenses: {
        hiteach: {
          name: 'HiTeach License (HiTeach 333 Stage 1)',
          duration: '3 Months'
        },
        aiPack: {
          name: 'Collaboration + Smart Rating + AI GPT',
          duration: '1 Month'
        },
        doubleAi: {
          name: 'Dual AI Gadgets',
          duration: '1 Year'
        }
      },
      completeQrTitle: 'Click or scan the QR code to download and install the HiTA 5 App',
      completeQrItems: {
        ios: 'Installation for iPhone iOS',
        androidPlay: 'Installation for Android',
        androidApk: 'Download HiTA 5 APK to Install'
      },
      notify: {
        title: 'Welcome to HiTeach 🎉',
        body: '"Dear {name} ({tmdId}),\nCongratulations on registering as a TEAM Model member!\n\nHighlight Features of HiTeach👉\n✅ AI Smart Teaching Assistant\n✅ Interactive Questioning\n✅ Multiple Assessment Modes\n✅ Data Analysis Reports\n\nStart your HiTeach exploration journey now:'
      },
      loginHT: 'Click to start using HiTeach'
    }
  }
}
